// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfServicePopup_root__X66bC","termsOfServiceWrapper":"TermsOfServicePopup_termsOfServiceWrapper__1om8K","acceptWrapper":"TermsOfServicePopup_acceptWrapper__1IZsM"};